import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsUp12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconThumbsUp12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.501 5 6.2 1.4C6.776.633 8 1.04 8 2v2.983h1.755a1.5 1.5 0 0 1 1.385 2.075L9.884 10.09a1.5 1.5 0 0 1-1.386.925H2.5a1.5 1.5 0 0 1-1.5-1.5v-3.02a1.5 1.5 0 0 1 1.511-1.5l.948.007zM3 5.998l-.496-.003a.5.5 0 0 0-.504.5v3.02a.5.5 0 0 0 .5.5H3zm1 4.017h4.498a.5.5 0 0 0 .462-.308l1.256-3.032a.5.5 0 0 0-.461-.692H7V2.001L4.3 5.6l-.3.401z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsUp12);
